import React, { useState } from 'react'
import { DeletBCardWrapper } from './cardSettingsStyle'
import { useTypedSelector } from 'src/redux/root-reducer'
import { useNavigate, useParams } from 'react-router-dom'
import { deleteMyCardAction } from 'src/redux/actions/cards'
import { useDispatch } from 'react-redux'
import useSnackbar from 'src/hooks/useSnackBar'

const DeleteBankCard = () => {
  const cardsResult = useTypedSelector((state) => state.cards.myCards.cards)
  const params = useParams()
  const [loading, setLoading] = useState(false)
  const { id }: any = params
  const card = cardsResult.filter(function (el: any) {
    return el.id >= id
  })
  const dispatch = useDispatch()

  const deleteCard = (e: any) => {
    e.preventDefault()
    setLoading(true)
    dispatch(deleteMyCardAction({ id, onSuccess, onError }))
  }
  const snackbar = useSnackbar()
  const navigate = useNavigate()

  const onSuccess = (msg: any) => {
    setLoading(false)
    snackbar.trigger({
      message: msg,
      severity: 'success',
    })
    navigate(-1)
  }

  const onError = (error: any) => {
    setLoading(false)
    snackbar.trigger({
      message: 'This card does not exist or has been deleted.',
      severity: 'error',
    })
  }

  return (
    <DeletBCardWrapper>
      {card
        ? card.map((item: any) => {
            return (
              <div className="delete_card_container">
                {/* <div className="center">
                  <img src={item.card_logo} alt="" className="card" />
                </div> */}
                <div className="card-detail">
                  <h2 className="card-title">Card number</h2>
                  <p className="card-title-text">
                    {item.card_prefix}******{item.card_suffix}
                  </p>
                </div>
                <div className="card-detail">
                  <h2 className="card-title">Exp</h2>
                  <p className="card-title-text">
                    {item.expiry_month}/{item.expiry_year}
                  </p>
                </div>
                <div className="card-detail">
                  <h2 className="card-title">Card type</h2>
                  <p className="card-title-text">{item.card_type}</p>
                </div>
                <div className="center">
                  <p onClick={deleteCard}>
                    {/* Delete {loading && 'deleting.....'} */}
                    {loading ? 'Deleting...' : 'Delete'}
                  </p>
                </div>
              </div>
            )
          })
        : null}
    </DeletBCardWrapper>
  )
}

export { DeleteBankCard }
